import LightningTemplate from '@/modules/questionnaire/components/steps/photo-analysis/skin-pigmentation/lightning/LightningTemplate';

export default {
  title: 'PhotoAnalysisSteps/SkinPigmentation/Lightning/LightningTemplate'
};

const createStory = componentProps => () => ({
  components: { LightningTemplate },
  componentProps,
  wrapStyles: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  template: `<div :style='$options.wrapStyles'>
    <lightning-template v-bind='$options.componentProps' />
  </div>`
});

export const Base = createStory({
  wishesLightening: 'no'
});
